import { displayToast, displayFormErrors, sendAppsignalError } from "../modules/utils";

export default class AjaxForm {
  constructor(node) {
    this.element = node;

    this.resultElement = document.getElementById(this.element.dataset.resultElementId);

    this.initialize();
  }

  initialize() {
    this.element.addEventListener("submit", (e) => {
      e.preventDefault();

      if (this.element.dataset.shouldHandleSubmit === "true") {
        this.handleBeforeSubmit();
      } else {
        this.saveForm();
      }
    });
  }

  handleBeforeSubmit() {
    this.element.addEventListener(
      "ajax:before-submit-complete",
      () => {
        this.saveForm();
      },
      { once: true }
    );

    this.element.dispatchEvent(new CustomEvent("ajax:before-submit"));
  }

  saveForm() {
    if (this.resultElement) {
      this.resultElement.classList.add("is-loading");
    }

    const formData = new FormData(this.element);

    fetch(this.element.action, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
      processData: false,
      contentType: false,
    })
      .then(async (response) => {
        let { status } = response;
        this.response = response;
        this.status = status;

        if (this.status === 200 || this.status === 422 || this.status === 201) {
          return response.json().catch(() => null);
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        if (this.status === 201) {
          // We just redirect to the location provided
          window.location.href = data.url;
        }

        if (this.status === 422) {
          // We now have support for either directly the errors or an object in the form of { errors: { field: "message" } }
          displayFormErrors(this.element, data.errorMessages || data);
          displayToast(this.element.dataset.errorMessage);
          return;
        }

        displayToast(this.element.dataset.successMessage, "success");

        if (this.resultElement) {
          this.resultElement.dispatchEvent(new CustomEvent("ajax:post", { detail: data.htmlContent || data }));
        }

        this.element.dispatchEvent(new Event("ajax:successful-post"));
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "AjaxForm", {
          response: this.response,
        });
      })
      .finally(() => {
        if (this.resultElement) {
          this.resultElement.classList.remove("is-loading");
        }
      });
  }
}
